"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const contact_1 = __importDefault(require("../contact"));
const errors_1 = __importStar(require("../errors"));
class Carrier extends contact_1.default {
    constructor(mode, id, name, email, phone, ein, address, carrierId) {
        super(id, name, email !== null && email !== void 0 ? email : "", address, phone, ein);
        this.mode = mode;
        this.carrierId = carrierId;
    }
    validate(data, isPrimary = true) {
        const errors = [];
        if (!this.mode) {
            errors.push(new errors_1.default(errors_1.eErrorCode.TRANSPORT_MODE_NOT_SET, `${data}.mode`));
        }
        if (isPrimary) {
            errors.push(...super.validate(data, true, false));
        }
        return errors;
    }
    static getTransportModes() {
        return Object.keys(_1.eTransportMode)
            .filter((key) => typeof _1.eTransportMode[key] === "string")
            .map((key) => _1.eTransportMode[key]);
    }
    generateIdIfEmpty() {
        if (!this.id && this.name && this.mode) {
            const lName = this.name.toLocaleLowerCase().replace(/ /g, "");
            const lMode = this.mode.toLocaleLowerCase().replace(/ /g, "");
            this.id = Buffer.from(`${lName}-${lMode}`).toString("base64");
        }
        return this.id;
    }
}
exports.default = Carrier;
//# sourceMappingURL=carrier.class.js.map